export const rfqFormConfig = {
  basicInfo: [
    {
      name: "industry",
      label: "Industry *",
      type: "select",
      options: [
        "Manufacturing",
        "Technology",
        "Healthcare",
        "Automotive",
        "Electronics",
        "Construction",
        "Food & Beverage",
        "Textiles",
      ],
    },
    {
      name: "productCategory",
      label: "Product Category",
      type: "select",
      options: [
        "Raw Materials",
        "Components",
        "Equipment",
        "Services",
        "Software",
        "Packaging",
      ],
    },
    {
      name: "subProductCategory",
      label: "Sub-Product Category",
      type: "select",
      options: [
        "Metal Components",
        "Plastic Parts",
        "Electronic Components",
        "Software Licenses",
        "Consultation Services",
        "Quality Assurance",
      ],
    },
    {
      name: "leadName",
      label: "Lead Name *",
      type: "input",
      inputType: "text",
      placeholder: "Enter lead name",
    },
    {
      name: "quantity",
      label: "Quantity",
      type: "input",
      inputType: "number",
      placeholder: "Enter quantity",
    },
    {
      name: "description",
      label: "Description *",
      type: "textarea",
      placeholder: "Provide detailed description of your requirements...",
    },
    {
      name: "uploadImages",
      type: "file",
      label: "Upload Images",
      multiple: true,
      maxSizeMB: 5,
      accept: {
        "image/jpeg": [],
        "image/png": [],
      },
    },
    {
      name: "uploadVideos",
      type: "file",
      label: "Upload Videos",
      multiple: true,
      maxSizeMB: 50,
      accept: {
        "video/mp4": [],
        "video/quicktime": [],
      },
    },
    {
      name: "uploadPDFs",
      type: "file",
      label: "Upload PDFs",
      multiple: true,
      maxSizeMB: 10,
      accept: {
        "application/pdf": [],
      },
    },
  ],

  additionalDetails: [
    {
      name: "targetPrice",
      label: "Target Price",
      type: "input",
      inputType: "number",
      placeholder: "Enter target price",
    },
    {
      name: "port",
      label: "Port",
      type: "input",
      placeholder: "Enter port name",
    },
    {
      name: "shippingTerms",
      label: "Shipping Terms",
      type: "input",
      placeholder: "Enter shipping terms",
    },
    {
      name: "expiryDate",
      label: "Expiry Date",
      type: "date",
    },
    {
      name: "freightTerms",
      label: "Freight Terms",
      type: "select",
      options: [
        "FOB (Free on Board)",
        "CIF (Cost, Insurance, and Freight)",
        "CNF (Cost and Freight)",
        "EXW (Ex Works)",
        "DDP (Delivered Duty Paid)",
        "DAP (Delivered at Place)",
      ],
    },
    {
      name: "paymentTerms",
      label: "Payment Terms",
      type: "select",
      options: [
        "Net 30",
        "Net 60",
        "Net 90",
        "2/10 Net 30",
        "Cash on Delivery",
        "Letter of Credit",
        "Payment in Advance",
        "Installments",
      ],
    },
    {
      name: "sampleRequired",
      label: "Sample Required",
      type: "radio",
      options: ["yes", "no"],
    },
    {
      name: "Additionalfileuploads",
      label: "Additional File Uploads",
      type: "file",
      multiple: true,
      maxSizeMB: 50,
    },
  ],
};
